
































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* module */
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'

@Component
export default class GraphDialog extends Vue {
  public toggleComparisonFlag: boolean = false
  private defaultDate: string = '-月-日'
  private comparisonDate: string = '-月-日'
  private masterDate: string = '-月-日'
  private showPrediction: boolean = false
  private showPredictionComparison: boolean = false
  private graphData: {[key: string]: number} = {
    growth_height: 0,
    integration_temperature: 0,
    soil_moisture: 0,
    spad: 0,
    stem_number: 0,
    stem_number_m2: 0
  }
  private masterData: {[key: string]: number} = {
    growth_height: 0,
    integration_temperature: 0,
    soil_moisture: 0,
    spad: 0,
    stem_number: 0,
    stem_number_m2: 0
  }
  private comparisonData: {[key: string]: number} = {
    growth_height: 0,
    integration_temperature: 0,
    soil_moisture: 0,
    spad: 0,
    stem_number: 0,
    stem_number_m2: 0
  }
  private stemNumType: string = '1'

  @Prop() growthData!: any

  /* computed */
  private get growthList (): any {
    return this.$store.state.stageUpdateState.defaultStageData
  }
  private get setGraphDialogFlag () : boolean {
    return this.$store.state.setFlagState.graphDialogFlag
  }

  @Watch('growthList')
  updateList (newValue: any) {
    this.createdDialogData()
  }
  @Watch('setGraphDialogFlag')
  setGraphDate (flag: boolean) {
    this.createdDialogData()
  }

  created () {
    if (this.$store.state.graphToggleState.showComparison) {
      this.getComparisonData()
    }
  }
  mounted () {
    if (this.$store.state.setFlagState.graphDialogFlag) {
      this.createdDialogData()
    }
  }

  private displayValue (value: string|number) {
    return value !== null && value !== undefined ? value : '-'
  }

  private createdDialogData () {
    this.stemNumType = Session.getStemNumberType()!
    const plantingDate = DateClass.formingDate(Session.getPlantingDay()!)
    let newDate = new Date(plantingDate.getTime() + (this.growthData.elapsed_days * 24 * 60 * 60 * 1000))
    let keyDate = '' + newDate.getFullYear() + DateClass.toDoubleDigits(newDate.getMonth() + 1) + DateClass.toDoubleDigits(newDate.getDate())
    this.defaultDate = keyDate.slice(4, 6) + '月' + keyDate.slice(6, 8) + '日'

    // 実績か予測の判定
    let graphLastDay = Session.getGraphLastDay()!
    if (parseInt(keyDate) > parseInt(graphLastDay)) {
      this.showPrediction = true
    } else {
      this.showPrediction = false
    }

    this.getGprahData(keyDate)
    this.getMasterData(this.growthData.id)

    if (!this.$store.state.graphToggleState.hiddenComparisonData) {
      this.toggleComparisonFlag = true
      this.getComparisonData()
    } else {
      this.toggleComparisonFlag = false
    }

    this.$store.commit('setFlagState/setGraphDialogFlag', false)
  }

  private getGprahData (keyDate: string) {
    let graphData

    if (this.showPrediction) {
      graphData = JSON.parse(Session.getPredictionData()!)
    } else {
      graphData = JSON.parse(Session.getGraphData()!)
    }

    for (var key in graphData) {
      if (key === keyDate) {
        this.graphData = graphData[key]
      }
    }
  }

  private getMasterData (id: number) {
    let masterData = JSON.parse(Session.getMasterData()!)

    for (var i in masterData) {
      if (masterData[i].goal_growth_step === this.growthData.growth_step) {
        this.masterDate = i.slice(4, 6) + '月' + i.slice(6, 8) + '日'
        this.masterData = masterData[i]
      }
    }
  }

  private getComparisonData () {
    let step = this.growthData.growth_step
    let comparisonGraphData = JSON.parse(Session.getComparisonData()!)
    let comparisonStage = JSON.parse(Session.getComparisonStageData()!)
    let comparisonData = JSON.parse(Session.getComparisonPredictionData()!)

    // 比較のデータが取得できなかった場合、処理終了
    if (comparisonGraphData === null || comparisonData === null) {
      return
    }
    for (var key in comparisonStage) {
      if (step === comparisonStage[key].growth_step) {
        let day = Object.keys(comparisonGraphData)[comparisonStage[key].elapsed_days]

        // 実績があれば比較実績、なければ比較目標を表示
        if (day === undefined) {
          this.showPredictionComparison = true
          let count = 1
          let step = this.growthData.growth_step
          if (step !== 1) {
            step = this.growthData.growth_step - 1
          }

          for (var i in comparisonData) {
            if (count === step) {
              this.comparisonDate = i.slice(4, 6) + '月' + i.slice(6, 8) + '日'
              this.comparisonData = comparisonData[i]
            }
            count++
          }
        } else {
          this.showPredictionComparison = false
          this.comparisonDate = day.slice(4, 6) + '月' + day.slice(6, 8) + '日'
          this.comparisonData = comparisonGraphData[day]
          this.comparisonData.elapsed_days = comparisonGraphData[day].elapsed_days
        }
      }
    }

    this.toggleComparisonFlag = true
  }
}
